import { render, staticRenderFns } from "./AppealsRequest.vue?vue&type=template&id=3f943e3c&scoped=true"
import script from "./AppealsRequest.vue?vue&type=script&lang=js"
export * from "./AppealsRequest.vue?vue&type=script&lang=js"
import style0 from "./AppealsRequest.vue?vue&type=style&index=0&id=3f943e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f943e3c",
  null
  
)

export default component.exports